import { i18n } from './i18n.js';

class Formatter {
	constructor() {
    }

    // num, [fmt, prec, precMin], where num - number, nil -> 0
    // fmt - may be nil, 'money', 'price'
    // prec - may be nil, 0, 1, 2 ... If set, and precMax is not set, there always will be [prec] digits
    // precMax - nil, 0, ... - If set, there will be [prec ... precMax] digits
    formatNumber(num, fmt, prec, precMax) {
        // let lang = i18n.locale;
        if (!num) num = 0.;

        let m = Math.abs(num);
        if (fmt === 'price' && prec === undefined) {
            prec = m == 0 ? 0 : m > 10000 ? 0 : m > 2500 ? 1 : m > 500 ? 2 : m > 50 ? 3 :
                m > 2.5 ? 4 : m > 0.25 ? 5 : m > 0.05 ? 6 : 7;
            precMax = prec;
        }

        let prePtr = {};
        if (prec !== undefined) {
            if (precMax !== undefined)
                prePtr = { minimumFractionDigits: prec, maximumFractionDigits: precMax };
            else
                prePtr = { minimumFractionDigits: prec, maximumFractionDigits: prec };
        }

        return (num + 0.).toLocaleString('ru', prePtr);
    }

    // date, [fmtStr], where date - JS Date or correct date string
    // fmtStr can be nil (results in yyyy.MM.dd HH:mm)
    //   or 'd' (date only), or 't' (time only with seconds)
    //   or 'dt' (date + time with seconds)
    //   or 'dtm' (date + time with minutes only)
    //   or 'dts' (date + time with seconds)
    //   or 'dtmil' (date + time with milliseconds)
    //   or 'tm', 'ts', 'tmil'
    formatDateTime(date, fmtStr) {
        if (!date) return '';
        if (typeof date.getFullYear === "undefined") {
            try {
                if (date === parseInt(date, 10))
                    date = new Date(date);
                else
                    date = this.parseTimeString(date);
            } catch (e) {
                return '';
            }
        }
        if (!date || typeof date.getFullYear === "undefined")
            return '';
        if (!fmtStr) return this.formatDateFull(date, true, false);
        if (fmtStr === 'd') return this.formatDateOnly(date);
        if (fmtStr === 't') return this.formatTime(date, true, false);
        let start = fmtStr.startsWith('d') ? this.formatDateOnly(date) + ' ' : '';
        let needMils = fmtStr.endsWith('mil');
        let needSeconds = needMils || fmtStr.endsWith('s');
        return start + this.formatTime(date, needSeconds, needMils);
    }

    parseTimeString(s) {
        // '2017.05.16T11:34:33'
        if (!s || s.length < 8) return null;
        let dateTime = s.split(/[\sT]+/);
        if (!dateTime.length) return null;
        
        let parts = dateTime[0].split(/[.-]+/);
        if (parts.length != 3) return null;
        let y = parseInt(parts[0]);
        let m = parseInt(parts[1]) - 1;
        let d = parseInt(parts[2]);

        let hr = 0, min = 0, sec = 0, ms = 0;
        if (dateTime.length === 2) {
            parts = dateTime[1].split(/[:.]+/);
            if (parts.length > 0)
                hr = parseInt(parts[0]);
            if (parts.length > 1)
                min = parseInt(parts[1]);
            if (parts.length > 2)
                sec = parseInt(parts[2]);
            if (parts.length > 3)
                ms = parseInt(parts[3]);
        }
        return new Date(y, m, d, hr, min, sec, ms);
    }

    // options: { format: 'date' | 'time' | 'datetime' (default),
    //            needSeconds: true, needMils: false }
    formatServerDateTimeString(str, options) {
    	//2018-09-27T15:27:47.6119986
    	try {
    		let date = new Date(str);
    		if (!options)
    			return this.formatDateFull(date, true, false);
    		let needSeconds = (options && options.needSeconds === false) ? false : true;
    		let needMils = (options && options.needMils === true) ? true : false;

    		if (options.format === 'time')    			
    			return this.formatTime(date, needSeconds, needMils);

    		if (options.format === 'date')
    			return this.formatDateOnly(date);

    		return this.formatDateFull(date, needSeconds, needMils);

    	} catch (e) {
    		return str;
    	}
    }

    parseDateTime(s) {
        if (!s || s.length < 8) return null;
        
        try {
            let parts = s.split(/[\s,T]+/);
            if (parts.length != 2) return null;

            let dateParts = parts[0].split(/[.-]+/);
            if (dateParts.length != 3) return null;

            let timeParts = parts[1].split(/[.:]+/);
            if (timeParts.length < 2) return null;

            let mils = timeParts.length > 3 ? parseInt(timeParts[3]) : 0;
            let secs = timeParts.length > 2 ? parseInt(timeParts[2]) : 0;
            let mins = parseInt(timeParts[1]);
            let hors = parseInt(timeParts[0]);

            let days = parseInt(dateParts[2]);
            let mons = parseInt(dateParts[1]);
            let yers = parseInt(dateParts[0]);

            return new Date(yers, mons, days, hors, mins, secs, mils);
        } catch (e) {
            console.log(`Date-time string is malformatted: [${s}]`);
        }
    }

    getToday() {
        let time = new Date();
        return new Date(time.getFullYear(), time.getMonth(), time.getDate());
    }

    formatDateOnly(date) {
    	return `${date.getFullYear()}-${twoDig(date.getMonth()+1)}-${twoDig(date.getDate())}`;
    }

    formatDateFull(date, needSeconds, needMils) {
    	return `${this.formatDateOnly(date)} ${this.formatTime(date, needSeconds, needMils)}`;
    }

	formatTime(date, needSeconds, needMils) {
    	let mainPart = `${twoDig(date.getHours())}:${twoDig(date.getMinutes())}`;
    	if (!needSeconds) return mainPart;
    	mainPart += (':' + twoDig(date.getSeconds()));
    	if (!needMils) return mainPart;
    	return mainPart + '.' + threeDig(date.getMilliseconds());
    }

    getWeekNumInYear(date) {
        let nextDate = new Date (date);
        let onejan = new Date(nextDate.getFullYear(), 0, 1);
        return Math.ceil((((nextDate - onejan) / 86400000) + onejan.getDay() + 1) / 7);
    } 
}

function twoDig(num) {
    return num < 10 ? '0' + num : '' + num;
}

function threeDig(num) {
    return num < 10 ? '00' + num : num < 100 ? '0' + num : '' + num;
}

export let formatter = new Formatter();